import request from "../base-request";

/**
 * Fetches Hashtags
 */
export const fetchHashtags = async (searchTerm?: string) => {
	const [data] = await request<{ hashtags: string[] }>(`/api/v0.1/feedback-hashtags/${searchTerm || ""}`);

	return data["hashtags"] || [];
};
